export const GetToken = () => {
  const token = localStorage.getItem("delivery_token");
  return token;
};

export const GetUser = () => {
  const data = localStorage.getItem("delivery_user");
  if (data) {
    try {
      return JSON.parse(data);
    } catch (e) {
      return {};
    }
  }
  return {};
};

export const Logout = () => {
  localStorage.removeItem("delivery_token");
  localStorage.removeItem("delivery_user");
};